import { type ClassValue, clsx } from 'clsx'
import { toast } from 'sonner'
import { twMerge } from 'tailwind-merge'

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function formatDate(date: string | Date) {
  return new Date(date).toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  })
}

export function truncateText(text: string, maxLength: number) {
  if (text.length <= maxLength) return text
  return text.slice(0, maxLength) + '...'
}

export function debounce<T extends (...args: any[]) => any>(
  func: T,
  wait: number
) {
  let timeout: NodeJS.Timeout

  return function executedFunction(...args: Parameters<T>) {
    const later = () => {
      clearTimeout(timeout)
      func(...args)
    }

    clearTimeout(timeout)
    timeout = setTimeout(later, wait)
  }
}

// Utility function to get profile picture URL
export function getProfilePictureUrl(email: string, originalPictureUrl?: string): string {
  // If no original picture URL, use the proxy endpoint
  if (!originalPictureUrl) {
    return `/api/profile-picture/${encodeURIComponent(email)}`;
  }
  
  // If it's a Google profile picture, use the proxy to avoid CORS
  if (originalPictureUrl.includes('googleusercontent.com')) {
    return `/api/profile-picture/${encodeURIComponent(email)}`;
  }
  
  // For other URLs, use the original
  return originalPictureUrl;
}

export const showSuccessToast = (message: string) => {
  toast.success(message);
};

export const showErrorToast = (message: string) => {
  toast.error(message);
};

export const showInfoToast = (message: string) => {
  toast.info(message);
};
